import { useAuth } from "../../../../context";
import { useMutation } from "react-query";
import { Location } from "../../../../api/supplier-questionnaire/location";

export function useCreateLocation(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Location.createLocation, { questionnaireId, data }), config);
}

export function useUpdateLocation(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(Location.updateLocation, { questionnaireId, id, data }), config);
}